import Api from '@common/services/api';
import { CompetancyPayload } from '../types';

export const updateCompetancy = async (
  organisationId: string,
  competencyId: string,
  payload: CompetancyPayload
) => {
  const { data } = await Api.put(
    `/v1/organisations/${organisationId}/performance/competencies/${competencyId}`,
    payload
  );

  return { data };
};
